import React, { useState, useEffect } from "react";
import "./CookieConsent.css";

const CookieConsent = ({ onAccept, onDecline }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
    if (onAccept) onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
    if (onDecline) onDecline();
  };

  const handleCustomize = () => {
    // For now, this will show a simple alert. You can expand this to show detailed settings
    alert(
      "Cookie customization feature coming soon! For now, please accept or decline."
    );
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-popup">
        <div className="cookie-header">
          <h3> Cookie Notice</h3>
        </div>

        <div className="cookie-content">
          <p>
            We use cookies to enhance your browsing experience, serve
            personalized content, and analyze our traffic. By clicking "Accept
            All", you consent to our use of cookies.
          </p>

          <div className="cookie-details">
            <div className="cookie-type">
              <strong>Essential Cookies:</strong> Required for website
              functionality (login, cart)
            </div>
            <div className="cookie-type">
              <strong>Analytics Cookies:</strong> Help us understand website
              usage
            </div>
            <div className="cookie-type">
              <strong>Marketing Cookies:</strong> Used for personalized
              advertising
            </div>
          </div>
        </div>

        <div className="cookie-actions">
          <button
            className="cookie-btn cookie-btn-accept"
            onClick={handleAccept}
          >
            Accept All
          </button>
          <button
            className="cookie-btn cookie-btn-decline"
            onClick={handleDecline}
          >
            Decline
          </button>
        </div>

      </div>
    </div>
  );
};

export default CookieConsent;
